import { Link } from "react-router-dom";
import { Bed, Users, Maximize2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useCurrency } from "@/lib/currency";

export default function RoomCard({ room, query = "" }) {
  const { t, trField } = useI18n();
  const { format } = useCurrency();
  const photo = room.photos?.[0] || "https://images.unsplash.com/photo-1776876648949-63ccabf63b10?w=1200&q=80";
  const name = trField(room, "name");
  const short = trField(room, "short_description");
  return (
    <Link
      to={`/rooms/${room.id}${query}`}
      data-testid={`room-card-${room.id}`}
      className="group block animate-fade-up"
    >
      <div className="overflow-hidden rounded-sm bg-white">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={photo}
            alt={name}
            className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
            loading="lazy"
          />
        </div>
      </div>
      <div className="pt-5">
        <div className="flex justify-between items-baseline gap-4">
          <h3 className="font-display text-2xl text-brand-text leading-tight">{name}</h3>
          <div className="text-right shrink-0">
            <div className="font-display text-xl text-brand-primary">{format(room.price_per_night)}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-brand-muted">{t("rooms.per_night")}</div>
          </div>
        </div>
        <p className="mt-2 text-sm text-brand-muted leading-relaxed line-clamp-2">{short}</p>
        <div className="mt-4 flex flex-wrap gap-4 text-xs text-brand-muted">
          <span className="flex items-center gap-1.5"><Users size={13} /> {room.max_guests} {room.max_guests > 1 ? t("widget.guests_plural") : t("widget.guest")}</span>
          <span className="flex items-center gap-1.5"><Bed size={13} /> {room.beds} bed{room.beds > 1 ? "s" : ""}</span>
          {room.size_sqm ? (
            <span className="flex items-center gap-1.5"><Maximize2 size={13} /> {room.size_sqm} m²</span>
          ) : null}
        </div>
      </div>
    </Link>
  );
}
